import { createSlice } from "@reduxjs/toolkit";
import {
  fetchReferralByID,
  fetchReferralsItems,
  fetchReferralsItemsByMemberID,
  updateReferral,
} from "./ReferralsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
  referralDetails: null, // ← for single referral
};

const referralsSlice = createSlice({
  name: "referrals",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferralsItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReferralsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchReferralsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchReferralsItemsByMemberID.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReferralsItemsByMemberID.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
      })
      .addCase(fetchReferralsItemsByMemberID.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // update referral
      .addCase(updateReferral.fulfilled, (state, action) => {
        const updated = action.payload;
        const index = state.items.findIndex((item) => item._id === updated._id);
        if (index !== -1) {
          state.items[index] = updated;
        }
      });
    builder.addCase(fetchReferralByID.fulfilled, (state, action) => {
      state.referralDetails = action.payload;
    });
  },
});

export default referralsSlice.reducer;
